import Button from "../ui/Button";
import { useCashierText } from "./cashierText";

export default function AsyncState({
  loading,
  error,
  empty,
  onRetry,
  children, 
}) {
  const { t } = useCashierText();
  if (loading)
    return (
      <div className="cashier-empty" role="status">
        {t.loading}
      </div>
    );
  if (error)
    return (
      <div className="cashier-empty cashier-error">
        <p>{error}</p>
        <Button
              variant="primary"
              appearance="filled"
              size="sm" onClick={onRetry}>{t.retry}</Button>
      </div>
    );
  if (empty)
    return <div className="cashier-empty">{t.emptyToday}</div>;
  return children;
}
